// Connection status component showing WebSocket, Auth, and Main App status

import React from 'react';
import styles from './ConnectionStatus.module.css';

const ConnectionStatus = ({
  isWebSocketConnected,
  isAuthenticated,
  isMainAppConnected
}) => {
  const getStatusIcon = (status) => {
    return status ? '✓' : '○';
  };

  const getStatusClass = (status) => {
    return status ? styles.connected : styles.disconnected;
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Connection Status</h3>

      <div className={styles.statusGrid}>
        <div className={`${styles.statusItem} ${getStatusClass(isWebSocketConnected)}`}>
          <span className={styles.icon}>{getStatusIcon(isWebSocketConnected)}</span>
          <span className={styles.label}>WebSocket</span>
        </div>

        <div className={`${styles.statusItem} ${getStatusClass(isAuthenticated)}`}>
          <span className={styles.icon}>{getStatusIcon(isAuthenticated)}</span>
          <span className={styles.label}>Authenticated</span>
        </div>

        <div className={`${styles.statusItem} ${getStatusClass(isMainAppConnected)}`}>
          <span className={styles.icon}>{getStatusIcon(isMainAppConnected)}</span>
          <span className={styles.label}>Main App</span>
        </div>
      </div>

      {isMainAppConnected && (
        <div className={styles.successMessage}>
          ✓ Fully Connected - Ready to use
        </div>
      )}

      {isAuthenticated && !isMainAppConnected && (
        <div className={styles.waitingMessage}>
          ⏳ Waiting for main app to connect...
        </div>
      )}
    </div>
  );
};

export default ConnectionStatus;
